import { Stack, Typography, useTheme } from '@mui/material';
import React, { memo } from 'react';

const formatNumber = (number: number) => number.toLocaleString('en-US');

interface SumChartProps {
  dataCount: {
    title: string;
    value: number;
  }[];
}

const SumChart: React.FC<SumChartProps> = ({ dataCount }) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        gap: '10px',
        '& *': {
          fontWeight: '700 !important',
        },
      }}
    >
      {dataCount.map((item, index) => (
        <Stack
          key={`sum-chart-${index}`}
          flexDirection='row'
          justifyContent='space-between'
          sx={{
            borderRadius: '8px',
            borderLeft: '4px solid #3BBCD4',
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 4px 4px 0px #00000040',
            padding: '10px 15px',
            '& *': {
              fontSize: '20px !important',
            },
          }}
        >
          <Typography>{item.title}</Typography>
          <Typography color={theme.palette.primary.main}>
            {formatNumber(item.value)}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default memo(SumChart);
